import * as materials from "materials/legacy/legacy-shadowOnly";
export { materials };
export default materials;
